import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import customLanguageTexts from '../../../language'
import { getTimestampAsFullHumanDate, getPlanName } from '../../../helpers'
import './index.css'

const ModalSubscriptionDowngradeEndOfTerm = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'subscriptionDowngradedEndOfTerm'
  const visible = modalID === visibleModalID

  return (
    <Modal
      className="custom__downgradeEOT__modal"
      title={<div> {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_TITLE}</div>}
      open={visible}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="">
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_DESCRIPTION}
        <b>{getTimestampAsFullHumanDate(apps.active.downgradesAt)}</b>{' '}
        {apps.active.planDowngradedTo !== undefined ? (
          <span>
            {' '}
            to <b>{getPlanName(apps.active.planDowngradedTo, true)}</b>
          </span>
        ) : (
          ''
        )}
        <br />
        {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_NOTE}{' '}
        <i className="fe fe-smile ml-2" />
      </div>
    </Modal>
  )
}

export default ModalSubscriptionDowngradeEndOfTerm
